import React from 'react';

import { Box, Typography } from '@mui/material';
import {
  becameValueStyles,
  diffArrowStyles,
} from 'app/shared/modules/EntityAuditHistory/EntityAuditHistory.styles';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { beforeValueStyles, lineStyles, linesStyles, valueStyles } from './BeforeAfterLines.styles';

/**
 * Before → after pairs, the old value struck above the new one, which the arrow leads. An added value
 * shows only its after side, a removed one only its before.
 */
const BeforeAfterLines = ({ lines }) => (
  <Box sx={linesStyles}>
    {lines.map(line => (
      <Box key={line.key} sx={lineStyles}>
        {!_.isNil(line.before) && (
          <Typography component="span" sx={beforeValueStyles} variant="regular14">
            {line.before}
          </Typography>
        )}
        {!_.isNil(line.after) && (
          <Box component="span" sx={becameValueStyles}>
            {!_.isNil(line.before) && (
              <Box component="span" sx={diffArrowStyles}>
                →
              </Box>
            )}
            <Typography component="span" sx={valueStyles} variant="regular14">
              {line.after}
            </Typography>
          </Box>
        )}
      </Box>
    ))}
  </Box>
);

BeforeAfterLines.propTypes = {
  lines: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      before: PropTypes.string,
      after: PropTypes.string,
    }),
  ).isRequired,
};

export default BeforeAfterLines;
